import { cmApi } from '@/api/cmApi'
import { authHeaders } from '@/auth/session'

export type BookmakerSessionFlag = 'all' | 'onlyBookmaker' | 'onlySession' | 'bookmakerSession'

export type PermissionAction = { code: string; label: string }
export type PermissionRole = { accessRole: string; actions: PermissionAction[] }
/** CSV: Menu → Access Role (tab) → functionalities */
export type PermissionMenu = { menu: string; roles: PermissionRole[] }

export type FpAuthorisePage = {
  pageName: string
  url: string
  feature: string[]
}

export type StaffUser = {
  id: string
  ownerId: string
  username: string
  status: 'active' | 'inactive'
  bookmakerSessionFlag: BookmakerSessionFlag
  grants: string[]
  accessRoleName?: string | null
  authorise?: FpAuthorisePage[]
  hasPassword: boolean
  createdAt: string
  updatedAt: string
}

export type CreateStaffUserBody = {
  username: string
  password?: string
  status?: 'active' | 'inactive'
  bookmakerSessionFlag?: BookmakerSessionFlag
  grants?: string[]
  accessRoleName?: string
  authorise?: FpAuthorisePage[]
}

export type UpdateStaffUserBody = {
  password?: string
  status?: 'active' | 'inactive'
  bookmakerSessionFlag?: BookmakerSessionFlag
  grants?: string[]
  accessRoleName?: string
  authorise?: FpAuthorisePage[]
}

export function listAccessPermissions() {
  return cmApi.staffPermissions(authHeaders())
}

export function listStaffUsers(query: { page?: number; keyword?: string }) {
  return cmApi.staffList(authHeaders(), query)
}

export function getStaffUser(id: string) {
  return cmApi.staffGet(authHeaders(), id)
}

export function createStaffUser(body: CreateStaffUserBody) {
  return cmApi.staffCreate(authHeaders(), body)
}

export function updateStaffUser(id: string, body: UpdateStaffUserBody) {
  return cmApi.staffUpdate(authHeaders(), { id, ...body })
}
